import style from "./Input.module.scss";
import { useState } from "react";
import { useEffect } from "react";
import { isString } from "lodash";

const Input = ({ type, label, value, required, onValueChange }) => {

    const [ currentValue, setCurrentValue ] = useState(value);
    const [ isFocused, setIsFocused ] = useState(false);

    useEffect(() => {
        if (value !== currentValue) {
            onValueChange(currentValue);
        }
    }, [ currentValue ])

    const id = `${type}-${Math.random()}`;

    return (
        <>
            <div className={ [ type !== 'checkbox' ? style.inputWrapper : style.checkboxWrapper, (isString(currentValue) && currentValue.length > 0) && style.withInput, isFocused && style.isFocused ].join(' ') }>
                { type !== 'checkbox' ? <>
                    <input id={ id } onChange={ (e) => {
                        setCurrentValue(e.target.value)
                    } } onFocus={ (e) => {
                        setIsFocused(true)
                    } } onBlur={ (e) => {
                        setIsFocused(false)
                    } } type={ type } defaultValue={ currentValue } placeholder={ label } required={ required ? true : false } className={ style.input } />
                    { label && <label htmlFor={ id }>{ label } { required && <span className={ style.required }>*</span> }</label> }
                </> : <label><input id={ id } onChange={ (e) => {
                    setCurrentValue(e.target.checked)
                } } type={ type } defaultChecked={ currentValue } required={ required ? true : false } className={ style.checkbox } /> { label } { required && <span className={ style.required }>*</span> }</label> }
            </div>
        </>
    )
}

export default Input;